import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import React from "react";
import { BiDownArrow, BiUpArrow } from "react-icons/bi";

const DesktopTimesheetTable = ({
  isMobile,
  timesheetLists,
  openRows,
  toggleOpen,
  getStatus,
}) => {
  console.log("timesheetLists", timesheetLists)
  return (
    <div>
      <JumboScrollbar
        autoHeight={true}
        autoHideTimeout={4000}
        autoHeightMin={400}
        autoHide={true}
        hideTracksWhenNotNeeded
        id="no-more-tables"
      >
        <Table
          stickyHeader
          className="table"
          size={isMobile ? "small" : "medium"}
        >
          <TableHead className="table-head">
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Employee Code</TableCell>
              <TableCell>Employee Name</TableCell>
              <TableCell>Timesheet Name</TableCell>
              <TableCell>From Time</TableCell>
              <TableCell>To Time</TableCell>
              <TableCell>Task Type</TableCell>
              <TableCell sx={{ minWidth: 400 }}>Task Carried Over</TableCell>
              <TableCell sx={{ minWidth: 145, maxWidth: 160 }}>
                Total Time Taken
              </TableCell>
              <TableCell
                sx={{
                  minWidth: "80px !important",
                  maxWidth: "100px !important",
                }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {timesheetLists?.length > 0 ? (
              timesheetLists?.flatMap((timesheet, sheetIndex) =>
                timesheet?.Timemanagement?.map((dayData, dayIndex) => {
                  const compositeKey = `${sheetIndex}-${dayIndex}`;
                  return (
                    <React.Fragment key={compositeKey}>
                      {/* Main Day Row */}
                      <TableRow>
                        <TableCell
                          data-title="Date"
                          onClick={() => toggleOpen(compositeKey)}
                          sx={{
                            cursor: "pointer",
                            minWidth: "120px !important",
                          }}
                        >
                          <DateFormatter date={dayData?.date} />
                          <span style={{ padding: 3 }}>
                            {openRows?.includes(compositeKey) ? (
                              <BiUpArrow />
                            ) : (
                              <BiDownArrow />
                            )}
                          </span>
                        </TableCell>
                        <TableCell data-title="Employee Code">
                          {timesheet?.Employee_Id?.Employee_Id}
                        </TableCell>
                        <TableCell data-title="Employee Name">
                          {`${timesheet?.Employee_Id?.Employee_FirstName} ${
                            timesheet?.Employee_Id?.Employee_LasttName || ""
                          }`}
                        </TableCell>
                        <TableCell
                          data-title="Timesheet Name"
                          sx={{ minWidth: "180px !important" }}
                        >
                          {timesheet?.Timesheet_Name}
                        </TableCell>
                        <TableCell data-title="From Time">
                          {dayData?.fromTime}
                        </TableCell>
                        <TableCell data-title="To Time">
                          {dayData?.toTime}
                        </TableCell>
                        <TableCell data-title="Task Type" />
                        <TableCell
                          data-title="Task Carried Over"
                          sx={{ minWidth: "350px !important" }}
                        />
                        <TableCell
                          data-title="Total Time"
                          sx={{ minWidth: "150px !important" }}
                        >
                          {dayData?.totalTime}
                        </TableCell>
                        <TableCell data-title="Status">
                          {/* {timesheet?.Timesheet_flg} */}
                          {getStatus(timesheet)}
                        </TableCell>
                      </TableRow>

                      {/* Expanded Task Rows */}
                      {openRows?.includes(compositeKey) &&
                        dayData?.taskCarried?.map((task, taskIndex) => (
                          <TableRow
                            key={`${compositeKey}-${taskIndex}`}
                            sx={{ backgroundColor: "#F3FCFF" }}
                          >
                            <TableCell /> {/* Date */}
                            <TableCell colSpan={2} />{" "}
                            {/* Spans Employee Code + Name */}
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell data-title="Task Type">
                              {task?.taskType}
                            </TableCell>
                            <TableCell
                              data-title="Task Carried Over"
                              sx={{
                                minWidth: "280px !important",
                              }}
                            >
                              {task?.task}
                            </TableCell>
                            <TableCell
                              data-title="Total Time"
                              sx={{
                                minWidth: "150px !important",
                              }}
                            >
                              {task?.hours}
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        ))}
                    </React.Fragment>
                  );
                }),
              )
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="left">
                  No Records
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </JumboScrollbar>
    </div>
  );
};

export default DesktopTimesheetTable;
